export default function createActionCreators(resourceName, key, actionTypes, api) {
	if (resourceName == null) throw new Error('actionCreatorsFor: Expected resourceName');

	let actionCreators = {

		create: function (data, token, queryParams) {
			return function (dispatch) {
				dispatch(actionCreators.request());

				return api.create(data, token, queryParams)
					.then(
						response => dispatch(actionCreators.success(response)),
						error => dispatch(actionCreators.failure(error))
					).then(
						response => dispatch(actionCreators.complete()),
						error => dispatch(actionCreators.complete())
					);
			}
		},

		request: function () {
			let name = resourceName + '_CREATE_REQUEST';

			return {
				type: actionTypes[name]
			}
		},

		success: function (data) {
			let name = resourceName + '_CREATE_SUCCESS';

			return {
				data: data,
				type: actionTypes[name]
			}
		},

		complete: function () {
			let name = resourceName + '_CREATE_COMPLETE';

			return {
				data: {},
				type: actionTypes[name]
			}
		},

		failure: function (error, data) {
			let name = resourceName + '_CREATE_FAILURE';

			return {
				data: data,
				error: error,
				type: actionTypes[name]
			}
		}
	};

	return actionCreators;
}